import AuthMixin from '@/components/mixins/AuthMixin'
import CompanyServiceFeeMixin from '@/components/mixins/CompanyServiceFee'

export default {
    mixins: [AuthMixin, CompanyServiceFeeMixin],
    computed: {
        companyAdminHeaders() {
            return [
                {
                    value: 'createdAt',
                    text: this.$t('labels.identifier'),
                    type: 'string',
                    width: 120,
                },
                {
                    value: 'status',
                    text: this.$t('labels.status'),
                },
                {
                    value: 'requiredDeliveryTime',
                    text: this.$t('orders.dropoff_at'),
                    type: 'string',
                },
                {
                    value: 'restaurantName',
                    text: this.$t('orders.vendor'),
                },
                {
                    value: 'deliveryName',
                    text: this.$t('labels.customer'),
                    type: 'string',
                },
                {
                    value: 'costCode',
                    text: this.$t('labels.cost_code'),
                    sortable: false,
                },
                {
                    value: 'priceTotal',
                    text: this.hasServiceFee
                        ? this.$t('labels.invoice_total')
                        : this.$t('labels.payment'),
                    type: 'string',
                },
            ]
        },
        headers() {
            const headers = [
                {
                    value: 'createdAt',
                    text: this.$t('labels.identifier'),
                    type: 'string',
                    width: 120,
                },
                {
                    value: 'status',
                    text: this.$t('labels.status'),
                },
            ]

            if (this.isSuperAdmin) {
                headers.push({
                    value: 'deliveryJob',
                    text: this.$t('labels.delivery'),
                    sortable: false,
                })
            }

            headers.push(
                {
                    value: 'deliveryJob.pickupTime',
                    text: this.$t('orders.pickup'),
                },
                {
                    value: 'requiredDeliveryTime',
                    text: this.$t('orders.dropoff_at'),
                    type: 'string',
                },
                {
                    value: 'deliveryName',
                    text: this.$t('labels.customer'),
                    type: 'string',
                },
                {
                    value: 'priceTotal',
                    text: this.hasServiceFee
                        ? this.$t('labels.invoice_total')
                        : this.$t('labels.payment'),
                    type: 'string',
                }
            )

            if (this.isSuperAdmin) {
                headers.push({
                    value: 'sent',
                    text: this.$t('labels.sent_ratio'),
                    sortable: false,
                })
            }

            if (this.isCompanyAdmin) {
                headers.push({
                    value: 'costCode',
                    text: this.$t('labels.cost_code'),
                    sortable: false,
                })
            }
            return headers
        },
    },
}
